module.exports = "<footer>\r\n  All information contained herein is for informational purposes only and should not be construed as an investment or securities offering of any kind.\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main